import axios from 'axios';
import {ElMessage, ElNotification} from 'element-plus';
import router from "../router";
import {getToken, removeToken} from "@/utils/auth";

let _headers = {};
let HOST = "";

export let _handle = {
  redirect: {},
  showMsg: {}
};

class KingfisherService {

  constructor(param = {}) {
    this.host = param.host || '';

    this.errorStatus = {
      message: '',
      statusCode: -1,
      screen: ''
    };

    this.context = "/portal";
    if (param.context) {
      this.context = param.context;
    }
  }

  static setHeader(headers) {
    Object.keys(headers).forEach(key => {
      _headers[key] = headers[key];
    });
  }

  static hasHeader(key) {
    return !!_headers[key];
  }

  static get header() {
    return _headers;
  }

  static setHost(host) {
    HOST = host;
  }

  static get serverIP() {
    return HOST;
  }

  static setHandle(funcName, func) {
    _handle[funcName] = func;
  }

  getURL(url) {
    let result = this.host ? this.host : HOST;

    const isDev = 'development' === process.env.NODE_ENV;

    if (!url.startsWith("http")) {
      result = "/api" + url;
      /*if (isDev) {
        result = this.context + result;
      }*/
      result = this.context + result;
     /* let currUrl = window.location.href;
      currUrl = currUrl.substr(currUrl.indexOf("://") + 3);
      const contextPath = currUrl.substr(currUrl.indexOf("/"), currUrl.indexOf("/ui") - currUrl.indexOf("/"));
      result = contextPath + result;*/
    } else {
      result = url;
    }

    return result;
  }

  sendFetch(method, args) {
    let axOptions = {
      method: method,
      url: this.getURL(args[0]),
      data: args[1],
      headers: Object.assign(args[2] ? {} : {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authentication': getToken()
      }, args[2]),
    };
    if (args[2]) {
      Object.assign(axOptions, args[2]);
    }
    return axios(axOptions);
  }

  fetchPromise(method, args) {
    return new Promise((resolve, reject) => {
      this.sendFetch(method, args).then(res => {
            if (res.statusText === 'OK' || res.status === 200) {
              // resolve(res.data);
              this.handleConnection(resolve, reject, res.data);
            } else {
              reject(this.processFailed(res.data));
            }
          }, err => {
            console.warn(this.getURL(args[0]));
            if (err.response) {
              reject(this.processFailed(err.response));
            } else if (typeof err.message === 'string') {
              reject(this.processFailed(err.message));
            } else {
              reject(this.processFailed(err.message.response || {message: '网络错误'}));
            }
          }
      );
    });
  }

  handleConnection(resolve, reject, data) {
    if (data && data.kfSysCode && typeof data.kfSysCode == 'number') {
      const _msg = data.kfSysMsg ? data.kfSysMsg : 'System Error';

      const _code = data.kfSysCode;
      let _errMsg = _msg;
      switch (_code) {
        case 101: {
          _errMsg = '用户未找到';
          break;
        }
        case 102: {
          _errMsg = '用户或密码输入错误';
          break;
        }
        case 103: {
          _errMsg = '登录超时';
          break;
        }
        case 104: {
          _errMsg = '您的账号已在其他设备登录，您被迫下线';
          break;
        }
        case 106: {
          _errMsg = '登录超时';
          break;
        }
        case 200: {
          _errMsg = 'SSO登录已关闭';
          break;
        }
        case 201: {
          _errMsg = 'SSO用户未找到';
          break;
        }
        case 202: {
          _errMsg = 'SSO用户或密码输入错误';
          break;
        }
        case 304: {
          _errMsg = '微信登录失败，未知服务';
          break;
        }
        default: {
          _errMsg = '系统异常';
          break;
        }
      }
      if (this.lastErrorTime == null || this.lastError == null
          || new Date().getTime() - this.lastErrorTime > 1000 || _errMsg != this.lastError) {
        ElNotification({
          title: 'Warning',
          message: _errMsg,
          type: 'warning'
        });
        this.lastErrorTime = new Date().getTime();
        this.lastError = _errMsg;
      }
      if (_code === 103 || _code === 104 || _code === 106) {
        removeToken();
        router.push({path: '/'});
      }
      reject(this.processFailed(_msg));
    } else {
      resolve(data);
    }
  }

  processFailed(response) {
    if (typeof response === 'string') {
      this.errorStatus = {
        message: response,
        statusCode: null,
        screen: ''
      };
      return {response, errorStatus: this.errorStatus};
    }

    if (!response.status) {
      this.errorStatus = {
        message: response.message,
        statusCode: 0
      };
      if (process.env.PLATFORM === 'web') {
        ElMessage({
          type: 'warning',
          message: response.message
        });
      }
      return {response, errorStatus: this.errorStatus};
    }

    this.errorStatus = {
      message: '',
      statusCode: response.status,
      screen: ''
    };

    let message = "";
    switch (response.status) {
      case -1:
        this.errorStatus.message = response.message;
        return {response, errorStatus: this.errorStatus};
      case 0:
        ElMessage({
          type: 'warning',
          message: '请检查网络连接'
        });
        break;
      case 401:
        ElMessage({type: 'warning', message: '登录超时'});
        router.push({path: '/'});
        break;
      default:
        message = '发送请求失败：' + JSON.stringify(response.data);
        if (response.data.requestId) {
          message = `[${response.data.requestId}] ${
              response.data.message
          }`;
        }

        if (process.env.PLATFORM === 'web') {
          ElMessage({type: 'warning', message: message});
        }

        this.errorStatus.message = message;
        return {response, errorStatus: this.errorStatus};
    }
  }

  get() {
    return this.fetchPromise('GET', arguments);
  }

  post() {
    return this.fetchPromise('POST', arguments);
  }

  put() {
    return this.fetchPromise('PUT', arguments);
  }

  delete() {
    return this.fetchPromise('DELETE', arguments);
  }

}

export default KingfisherService;